module.exports = __webpack_public_path__ + "img/Progreso Icono.3272c413.svg";